/**
 * Valeria Monroy Silva (2548): mismos permisos de tickets que Paola (1312).
 * Ve, reasigna y contesta tickets de María Esther Segura (568)
 * y de Ángel López, jefe de mantenimiento (31).
 */
export const IDERP_VALERIA_MONROY = 2548

export function esJefeTickets (usuario) {
  if (!usuario) return false
  if (usuario.cargo === 'Jefe') return true
  return Number(usuario.iderp) === IDERP_VALERIA_MONROY
}
